var $ = require('jQuery');
/*require('./../../style/msg/base-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var Component = require('./../Component');
var EmotionHandler = require('../../../lib/EmotionHandler');
var MsgStatus = require('./../../constant/MsgStatus');
var config = require('./../../global/config');
var timeFormatter = require('../../utils/timeFormatter');
var strToNumCompare = require('../../../lib/util').strToNumCompare;
var is_file_helper = require('./../../global/utils').is_file_helper;
var gdic = require('./../../global/globalDic');
var utils = require('./../../global/utils');
var isEmpty = utils.isEmpty;
var isShopModeUser = utils.isShopModeUser;
var getShopKey = utils.getShopKey;
var isAnonymousSession = utils.isAnonymousSession;
var html2Text = require('../../utils/html2Text');

var replaceUrlSrc = function (txt) {
  var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/ig;
  var result = txt.replace(reg, function (item) {
    return "<a href='" + item + "' target='_blank'>" + item + "</a>";
  });
  return result;
};

var BaseMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: ''
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
    if (config['msg-avatar']) {
      self._element.addClass("im-has-avatar");
    } else {
      self._element.addClass("im-no-avatar");
    }
  })(this);

  // 是否已经被render过
  this._rendered = false;

  (function (self) {
    self._element.find('.im-msg-main .im-msg-send-status').click(function () {
      dispatcher.dispatch({
        type: ActionType.MSG_RESEND_APPLY,
        data: self._data.msg
      });
    });
  })(this);
};
BaseMsgItem.prototype = Object.create(Component.prototype);
BaseMsgItem.prototype.render = function () {
  //消息格式转换
  var msg = this._data.msg;

  if (this._data.showtime) {
    this._element.addClass('im-msg-showtime');
    // this._element.find(".im-msg-avatar").removeClass('im-msg-repair');
  } else {
    this._element.removeClass('im-msg-showtime');
    // this._element.find(".im-msg-avatar").addClass('im-msg-repair');
  }
  var avatar = (msg.sender_info && msg.sender_info.avatar) ? msg.sender_info.avatar : isAnonymousSession(msg.sender_info) ? config['default-anonymous-avatar']: config['default-avatar'];
  /*this._element.find(".im-msg-avatar").css({
   "background-image": 'url(' + avatar + ')'
   });*/
  if (!(msg.sender_info && msg.sender_info.hide_avatar)) {
    this._element.find(".im-msg-avatar").attr('src', avatar);
    // 加载失败之后，恢复默认图像
    this._element.find(".im-msg-avatar").error(function () {
      var current_src = $(this).attr('src');
      if (current_src !== config['default-avatar']) {
        $(this).attr('src', config['default-avatar']);
      }
    });
  } else {
    this._element.find(".im-msg-avatar").hide();
  }

  //收藏部分用户名
  if (msg.msg_showtype && msg.msg_showtype === 'collect') {

    this._element.find(".im-msg-avatar").hide();
    var title = msg.sender_info.user_name ? msg.sender_info.user_name:!isEmpty(msg.title) && msg.title.indexOf('群的聊天记录') != -1 ? '群聊':'未知';
    //var title = !isEmpty(msg.title) && msg.title.indexOf('群的聊天记录') != -1 ? '群' : msg.sender_info.user_name;
    this._element.find('.im-msg-collect-name').text(title);
    var time = timeFormatter(msg.send_time);
    this._element.find('.im-msg-collect-time').text(time);
  }

  // 群昵称展示
  var sendInfo = msg.sender_info;
  var username = (sendInfo && sendInfo.remark && sendInfo.remark.remark_name) ? sendInfo.remark.remark_name : (sendInfo && sendInfo.nick_name) ? sendInfo.nick_name : (sendInfo && sendInfo.user_name) ? sendInfo.user_name : '未知';
  this._element.find('.im-msg-user-name').text(username);

  // 是否为群消息
  if (msg.msg_type && msg.msg_type + '' === '1005') {
    this._element.addClass('im-group');
  } else if (!is_file_helper(msg.to_id, msg.to_source)) {
    var me = gdic.get('meInfo');
    if (isShopModeUser(msg, me) || isShopModeUser({ user_source: msg.sender_source }) || isShopModeUser({ user_source: msg.to_source })) {
      this._element.addClass('im-shop-mode');
      if (msg.msg_id > 0 && !msg.is_false_new) {
        // 已读未读展示
        var userKey = msg.to_id + '@' + msg.to_source;
        var me = config['me']();
        var shopKey = getShopKey(msg, me) ? getShopKey(msg, me) : null;
        var otherUserKey = shopKey ? userKey + '@@' + shopKey : userKey;
        if (gdic.get('otherRead-' + otherUserKey)) {
          msg.other_last_showed_msg_id = gdic.get('otherRead-' + otherUserKey);
        };
        var showedTxt = '未读';
        if (msg.msg_id && (msg.msg_id < 0 || !msg.other_last_showed_msg_id || (msg.other_last_showed_msg_id && strToNumCompare(msg.other_last_showed_msg_id + '', msg.msg_id + '') < 0))) {
          this._element.find('.im-msg-showed-status').addClass('unshowed');
        } else {
          showedTxt = '已读';
          this._element.find('.im-msg-showed-status').removeClass('unshowed');
        }
        this._element.find('.im-msg-showed-status').text(showedTxt);
      }
    }
  }

  if (!this._rendered) {
    this._rendered = true;
    if (msg.show_type !== 'wechat_notice_card') {
      if (msg.is_mine && !msg.is_in_float_view) {
        this._element.addClass('im-msg-me');
      }
      else {
        this._element.addClass('im-msg-other');
      }
    }
    var time = timeFormatter(msg.send_time);
    this._element.find('.im-msg-time').text(time);
    this.renderContent();
  }

  // if(msg.is_mine){
  this._element.find('.im-msg-content').data('msg-id', msg.msg_id);
  this._element.find('.im-chat-msg-contents').data('msg-id', msg.collect_id);
  // }

  if (this._options.multiple_selectable) {
    this._element.data('msg-id', msg.msg_id);
  }

  this._element.removeClass('im-msg-sending im-msg-fail');
  var handleFeedback = function () {
    this._element.addClass('im-msg-fail');
    this._element.find('.im-msg-feedback-content').html(msg.feedback);
    // 新添加的feedback的错误替换成服务器端推送tips消息
    if (msg.feedback_msg_hide + '' === '1') {
      this._element.addClass('im-msg-fail-hide');
    }
  };
  switch (msg.status) {
    case MsgStatus.UPLOADING:
      this._element.addClass('im-msg-sending');
      this.switchHandle && this.switchHandle(MsgStatus.UPLOADING);
      // if (msg.uploadingPercent) {
      //   this.handleUploadingPercent && this.handleUploadingPercent(msg.uploadingPercent);
      // }
      this.update && this.update();
      break;
    case MsgStatus.SENDING:
      this._element.addClass('im-msg-sending');
      if (msg.uploadingPercent) {
        msg.uploadingPercent += 30;
        /* this.handleUploadingPercent && this.handleUploadingPercent(msg.uploadingPercent);*/
        this.update && this.update();
      }
      break;
    case MsgStatus.SUCCESS:
      this.switchHandle && this.switchHandle(MsgStatus.SUCCESS);
      break;
    case MsgStatus.DOWNLOAD_FAIL:
      // 视频播放、文件下载出错。不需要展现重发的icon
      this._element.addClass('im-msg-send-status-hide');
      this.switchHandle && this.switchHandle(MsgStatus.DOWNLOAD_FAIL);
      handleFeedback.call(this);
      break;
    case MsgStatus.VIDEO_PLAY_ERROR:
      // 视频播放、文件下载出错。不需要展现重发的icon
      this._element.addClass('im-msg-send-status-hide');
      handleFeedback.call(this);
      break;
    case MsgStatus.CANCEL_SENDING:
      this.switchHandle && this.switchHandle(MsgStatus.CANCEL_SENDING);
      handleFeedback.call(this);
      break;
    case MsgStatus.UPLOAD_FAIL:
    case MsgStatus.FAIL:
      if (this._data.msg.content.type === 'file') {
        this.switchHandle && this.switchHandle(MsgStatus.FAIL);
      }
      handleFeedback.call(this);
      break;
    default:
      break;
  }
};
BaseMsgItem.prototype.setMsg = function (msg) {
  this.setData({
    msg: msg
  });
};
BaseMsgItem.prototype.getMsg = function () {
  return this._data.msg;
};
BaseMsgItem.prototype.showTime = function () {
  this.setData({
    showtime: true
  });
};
BaseMsgItem.prototype.hideTime = function () {
  this.setData({
    showtime: false
  });
};
BaseMsgItem.prototype.renderContent = function () {
};

module.exports = BaseMsgItem;
